var exports = {
  "rb": "AccountRestrictionScreen.module__selectable___bHVGMG",
  "wE": "AccountRestrictionScreen.module__directionScope___bHVGMG",
  "v5": "AccountRestrictionScreen.module__dialogBody___bHVGMG",
  "kL": "AccountRestrictionScreen.module__container___bHVGMG",
  "MT": "AccountRestrictionScreen.module__surface___bHVGMG",
  "qr": "AccountRestrictionScreen.module__footer___bHVGMG",
  "DD": "AccountRestrictionScreen.module__title___bHVGMG",
  "uW": "AccountRestrictionScreen.module__section___bHVGMG",
  "R_": "AccountRestrictionScreen.module__heading___bHVGMG",
  "z": "AccountRestrictionScreen.module__summary___bHVGMG",
  "Qq": "AccountRestrictionScreen.module__text___bHVGMG",
  "Cb": "AccountRestrictionScreen.module__fineText___bHVGMG",
  "ir": "AccountRestrictionScreen.module__reference___bHVGMG",
};

module.exports = exports;
